
export class ControlledPartyDto {

    partyId;
    name;
    idType;
    nip;
    pesel;
    foreignNumber;
    isBeneficiary;
    control;
 }